import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import api from '../services/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur serveur.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #0D1B2A 0%, #1A3B5D 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem',
    }}>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{
          background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px',
          padding: '3rem', maxWidth: '460px', width: '100%',
        }}
      >
        <Link to="/connexion" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontSize: '0.85rem', marginBottom: '2rem' }}>
          <ArrowLeft size={16} /> Retour à la connexion
        </Link>

        {!done ? (
          <>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔑</div>
              <h1 style={{ color: 'white', fontFamily: 'var(--font-display)', fontSize: '1.8rem', letterSpacing: '1px', marginBottom: '0.5rem' }}>
                MOT DE PASSE OUBLIÉ
              </h1>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem', lineHeight: 1.7 }}>
                Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
              </p>
            </div>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
              <div>
                <label style={{ display: 'block', color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem', marginBottom: '0.5rem', letterSpacing: '1px' }}>
                  EMAIL
                </label>
                <input
                  type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="votre@email.com" required
                  style={{
                    width: '100%', background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.15)', borderRadius: '10px',
                    padding: '0.9rem 1.2rem', color: 'white', fontSize: '0.95rem',
                    outline: 'none', boxSizing: 'border-box',
                  }}
                />
              </div>

              {error && (
                <div style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '0.8rem 1rem', color: '#FCA5A5', fontSize: '0.85rem' }}>
                  {error}
                </div>
              )}

              <button type="submit" disabled={loading} style={{
                background: loading ? 'rgba(255,107,0,0.5)' : 'linear-gradient(135deg, #FF6B00, #CC4400)',
                border: 'none', color: 'white', padding: '1rem',
                borderRadius: '10px', cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: 'var(--font-cond)', fontWeight: 700, fontSize: '0.95rem',
                letterSpacing: '1.5px', boxShadow: '0 10px 30px rgba(255,107,0,0.3)',
              }}>
                {loading ? 'Envoi en cours...' : 'ENVOYER LE LIEN'}
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>📧</div>
            <h2 style={{ color: 'white', fontFamily: 'var(--font-display)', fontSize: '1.8rem', marginBottom: '1rem', letterSpacing: '1px' }}>
              EMAIL ENVOYÉ !
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.8, marginBottom: '2rem' }}>
              Si un compte existe avec cet email, vous recevrez un lien de réinitialisation valable <strong style={{ color: 'var(--orange)' }}>1 heure</strong>.
            </p>
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', marginBottom: '2rem' }}>
              Vérifiez aussi vos spams.
            </p>
            <Link to="/connexion" style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
              background: 'linear-gradient(135deg, #FF6B00, #CC4400)',
              color: 'white', padding: '0.9rem 2rem', borderRadius: '10px',
              textDecoration: 'none', fontWeight: 700, fontSize: '0.9rem', letterSpacing: '1px',
            }}>
              RETOUR À LA CONNEXION
            </Link>
          </div>
        )}
      </motion.div>
    </div>
  );
}
